import { Link } from 'react-router-dom';
import { trendingVideos } from '@/mocks/videos';

export default function TrendingSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100">
              <i className="ri-fire-line text-accent-600 text-lg"></i>
            </div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900">热门推荐</h2>
          </div>
          <Link
            to="/category/movie"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors"
          >
            更多 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop>
          {trendingVideos.map((video, index) => (
            <Link
              key={video.id}
              to={`/video/${video.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  title={`${video.title} - 91视频网站高清播放`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-md bg-accent-500 text-white text-xs font-medium">
                    {index + 1 === 1 ? 'TOP 1' : index + 1 === 2 ? 'TOP 2' : index + 1 === 3 ? 'TOP 3' : `热门`}
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/70 text-white text-xs">
                  {video.duration}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90">
                    <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {video.views >= 10000 ? `${(video.views / 10000).toFixed(1)}万` : video.views.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500"></i>
                    {video.rating}
                  </span>
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 text-xs">{video.category}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}